import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import router from './router/router'
import vuetify from './plugins/vuetify';
import VueMask from 'v-mask';
import '@babel/polyfill'

Vue.config.productionTip = false;
Vue.use(VueMask);

/*
  Axios-настройки (упаковка / распаковка данных с сервера).
*/
import axios from 'axios';
import { restoreDatetimes } from './plugins/datetime';
import { removeTempIds } from './plugins/common';

// Максимальное время ответа - 5 секунд
axios.defaults.timeout = 5000;

axios.interceptors.request.use(config => {
  //if (config.data) removeTempIds(config.data);
  return config;
});

axios.interceptors.response.use(response => {
  if (response && response.data) {
    //console.log(restoreDatetimes);
    restoreDatetimes(response.data);
  } 
  return response;
}, err => {
  if (err.message.includes('401') && router.currentRoute.name != 'Login') {
    store.dispatch('logout');
    router.push('/login');
  }
  
  /*if (err.response == undefined || err.response.data == undefined || err.response.data.message == undefined) {
    err = {
      response: {
        data: {
          message: 'Ошибка сервера.'
        }
      }
    }
  }*/
  throw err;
});

/*
  Задаем общую функциональность и компоненты для всего приложения.
*/
import MainMenu from './components/common/MainMenu';
import DeleteButton from './components/common/DeleteButton';
import FilesTable from './components/common/FilesTable';
Vue.component('main-menu', MainMenu);
Vue.component('delete-button', DeleteButton);
Vue.component('files-table', FilesTable);

import { getLocal } from './plugins/datetime';
import {getTempId} from './plugins/common';
import validator from 'validator';
Vue.mixin({
  filters: {
    localDate(dt) {
      return getLocal(dt).date;
    },
    localDatetime(dt) {
      return getLocal(dt).datetime;
    },
    price(val) {
      return Number(val).toFixed(2);
    }
  },
  methods: {
    isEmail(v) {
      return validator.isEmail(v);
    },

    isUrl(v) {
      return validator.isURL(v);
    },

    isNumber(v) {
      return validator.isNumeric(String(v));
    },

    isInteger(v) {
      return validator.isNumeric(String(v)) && (Number(v).toFixed(0) == Number(v)) && (Number(v) >= 0);
    },

    scrollUp() {
      let modals = document.getElementsByClassName('v-dialog--active');
      if (modals.length > 0) {
        modals[modals.length - 1].scrollTop = 0;
      }
    },
    getTempId() {
      return getTempId();
    }
  }
});

// Создаем основной экземпляр Vue (и монтируем)
let vm = new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app');